/**
 * VistoeraTASK-00133 — Video Asset Picker sidebar count (facet) cache.
 *
 * Mirrors `ImageAssetPicker/imagePickerCountCache.ts` exactly (same
 * module-scoped, stale-while-revalidate, never-persisted-to-disk
 * contract) so reopening the Video Picker paints the last-known
 * `/video-assets/stats` result immediately instead of a blank/zeroed
 * sidebar while a fresh request revalidates it in the background.
 * Never shown across a different workspace (cache key includes it).
 */
import type { VideoAssetStats } from '../../api'

export interface VideoPickerCountCacheEntry {
  stats: VideoAssetStats
  cachedAtMs: number
}

const _cache = new Map<string, VideoPickerCountCacheEntry>()

export function videoPickerCountCacheKey(workspaceId: string): string {
  return workspaceId
}

export function getCachedVideoPickerStats(key: string): VideoPickerCountCacheEntry | null {
  return _cache.get(key) ?? null
}

export function setCachedVideoPickerStats(key: string, stats: VideoAssetStats): void {
  _cache.set(key, { stats, cachedAtMs: Date.now() })
}

/** Test/dev-only reset — never called from product code paths. */
export function _resetVideoPickerCountCacheForTests(): void {
  _cache.clear()
}
